// extracted by mini-css-extract-plugin
module.exports = {"totalRow":"DailyReportExternalTrafficTable_totalRow_2-5Ok"};